import { connect } from 'react-redux';
import Selection from '../../../components/Multiples/Selection';

import {
  triggerUpdateRightSidebar,
} from '../../../modules/rightSidebar/actions';

const mapDispatchToProps = {
  updateRightSidebar: triggerUpdateRightSidebar,
};

function mapStateToProps(state) {
  return {
    widthSize: state.getIn(['application', 'widthSize'], '')
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Selection);
